import React, { FC, ReactNode, useContext } from "react"
import { useFormContext } from "react-hook-form"
import { UpdatePhoneNumberHeaderAndCopy } from "components/views/account/phoneNumberUpdate/UpdatePhoneNumberHeaderAndCopy"
import { HR, Spacer } from "components/views/atoms/Atoms"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { Button } from "components/views/atoms/buttons/Button"
import { CountryCodeAndPhoneNumberInputs } from "components/views/account/phoneNumberUpdate/CountryCodeAndPhoneNumberInputs"
import {
  PhoneNumberUpdateModalContext,
  ResendState
} from "components/views/account/phoneNumberUpdate/UpdatePhoneNumberModal"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ResentButtonCopy: Record<ResendState, ReactNode> = {
  READY: l`Resend code`,
  SENDING: l`Sending`,
  SENT: l`Code resent`
}

const UpdatePhoneNumberFormStep: FC = () => {
  const { register, formState, errors } = useFormContext()
  const { onSubmit, onResend, resendState, onPhoneNumberChange, verificationCodeState } = useContext(
    PhoneNumberUpdateModalContext
  )

  return (
    <>
      <UpdatePhoneNumberHeaderAndCopy />
      <CountryCodeAndPhoneNumberInputs onChange={onPhoneNumberChange} />
      <Spacer height={1.5} />
      {verificationCodeState === "AWAITING_VERIFICATION" && (
        <CompleteFormInput
          ref={register({
            required: "Please enter the verification code"
          })}
          errors={errors}
          name="verificationCode"
          label={l`Enter verification code`}
        />
      )}
      <HR color="black-10" />
      <Spacer height={1.5} />
      {verificationCodeState === "AWAITING_VERIFICATION" ? (
        <div className="flex">
          <ButtonPrimary color="white" enabled={formState.isValid && formState.isDirty} onClick={onSubmit}>
            {formState.isSubmitting ? l`Sending...` : l`Confirm code`}
          </ButtonPrimary>
          <Spacer width={0.5} />
          <Button enabled={resendState !== "SENDING"} outline onClick={onResend}>
            {ResentButtonCopy[resendState]}
          </Button>
        </div>
      ) : (
        <ButtonPrimary
          color="white"
          disabledBackgroundColor="black-10"
          onClick={onSubmit}
          enabled={
            formState.isValid && formState.isDirty && (!formState.isSubmitting || verificationCodeState === "SENT")
          }
        >
          {formState.isSubmitting
            ? verificationCodeState === "SENT"
              ? l`Code sent!`
              : l`Sending...`
            : l`Send verification code`}
        </ButtonPrimary>
      )}
      <Spacer height={1.5} />
    </>
  )
}

export { UpdatePhoneNumberFormStep }
